import ReactDOM from 'react-dom'
import React from 'react'
import { getContext } from "kea";

import { renderPlugins, App, configActions, ROOT_ID, initI18n } from '@gratify-eu/cart/src'

let initStarted = false;

if(typeof window !== 'undefined' && typeof document !== 'undefined') {
  (function(window) {
    let gratify = {};

    const initPromise = new Promise((resolve, reject) => {
      gratify.init = async (appId, configuration = {}) => {
        const store = getContext().store;
        initStarted = true;
        window.gratify.appId = appId;
        let locale = null;
        try {
          locale = window.GRATIFY_LOCALE || null;
        } catch (e) {

        }
        // Set config
        if(configuration.language) {
          await initI18n({lng: configuration.language});
        }else {
          await initI18n();
        }
        store.dispatch(configActions.setConfig({ localeConfig: locale, ...configuration, appId }));
        let container = document.getElementById(ROOT_ID);
        window.gratify.store = store;

        if(!container) {
          container = document.createElement("div");
          container.id = ROOT_ID
          document.body.insertBefore(container, document.body.firstChild);
        }

        await renderPlugins(store);
        ReactDOM.render(
          <App />,
          container
        );

        resolve();
      }
    });

    gratify.setCartDefaults = async (defaults = {}) => {
      await initPromise;

      const store = getContext().store;
      store.dispatch(configActions.setCartDefaults({ ...defaults }));
    };

    gratify.addItemsToCart = async (items = []) => {
      await initPromise;

      const store = getContext().store;
      store.dispatch(configActions.addItemsToCart(items));
    };

    window.gratify = window.ecApi = gratify;
  })(window);
}
